.pan-buttons-container {
  // Non-IE styles here
  @supports not (-ms-high-contrast: none) {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $c-neutral-07;
    box-shadow: $shadow1;
  }

  // IE 11 styles here
  @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: none;
  }
}

.hide-pan-buttons-container {
  display: none;
}

.panning-button {
  height: 16px;
  width: 10px;
  cursor: pointer;
  opacity: 0.5;
  margin: 18px;
}

.panning-button-selected {
  height: 16px;
  width: 16px;
  opacity: 1;
}
